import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import './components/layout/main.scss';
import reportWebVitals from './reportWebVitals';
import Navigation from "./components/layout/navigation";
import Footer from "./components/layout/footer";
import Home from "./components/home/home";
import About from "./components/about/about"
import Collections from "./components/collections/collections";
import MyWallet from "./components/mywallet/mywallet";
import Assets from "./components/assets/assets";
import Transactions from "./components/transactions/transactions";
import Collection from "./components/collection/collection";
import Asset from "./components/asset/asset";


ReactDOM.render(
    <Router>
        <Navigation />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/asset" element={<Asset />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/mywallet" element={<MyWallet />} />
            <Route path="/transactions" element={<Transactions />} />
        </Routes>
        <Footer />
    </Router>,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
